import { useBooleanState, useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconArrowsUpDown } from '@calendly/ui/components/glyphs/IconArrowsUpDown';
import { BareItem } from '@calendly/ui/components/menu';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { NumberField } from '@calendly/ui/form/number-field';
import classNames from 'classnames';
import { useContext, useState, forwardRef } from 'react';
import { MeetingDetailDependenciesContext } from '../../../meeting_detail_context';
const itemContentsCss = "i36un1p";
const ItemContents = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemContentsCss, props.className)} />;
});
const modalContentCss = "mvoghhn";
const ModalContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalContentCss, props.className)} />;
});
const numberFieldCssCss = "n1qwr9mo";
const NumberFieldCss = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(numberFieldCssCss, props.className)} />;
});
const InviteeLimitModal = ({
  event,
  onClose
}) => {
  const dependencies = useContext(MeetingDetailDependenciesContext);
  if (!dependencies?.useUpdateEventAttributesMutation) {
    throw new Error('EditInviteeLimitButton must be wrapped in a MeetingDetailDependenciesProvider with useUpdateEventAttributesMutation');
  }
  const [updateEventAttributes, {
    error,
    isLoading,
    isSuccess
  }] = dependencies.useUpdateEventAttributesMutation();
  const [currentLimit, setCurrentLimit] = useState(event.inviteesLimit);
  const errors = error?.type === 'validation' ? error.payload.inviteesLimit : [];
  const onConfirm = () => {
    updateEventAttributes({
      id: event.id,
      attributes: {
        inviteesLimit: currentLimit
      }
    });
  };
  useOnValueChange(isSuccess, () => {
    if (!isSuccess) return;
    onClose();
  });
  return <Popup title={I18n.t('publisher.dashboard.event.invitee_limit')} onClose={onClose}>
      <Body>
        <ModalContent>
          <BodyText>
            {I18n.t('publisher.dashboard.event.edit_invitee_limit_for_event')}
          </BodyText>
          <NumberField name="invitees_limit" value={currentLimit} aria-label={I18n.t('publisher.dashboard.event.invitee_limit')} error={errors[0]} className={NumberFieldCss} onChange={e => setCurrentLimit(e.target.value)} />
        </ModalContent>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button loading={isLoading} onClick={onConfirm}>
          {I18n.t('publisher.action.apply')}
        </Button>
      </Footer>
    </Popup>;
};
export const EditInviteeLimitButton = ({
  event
}) => {
  const [isModalOpen, openModal, closeModal] = useBooleanState(false);
  return <>
      <BareItem onClick={openModal}>
        <ItemContents>
          <UiIcon icon={IconArrowsUpDown} size="small" />
          {I18n.t('publisher.meetings.invitees.edit_invitee_limit')}
        </ItemContents>
      </BareItem>
      {isModalOpen && <InviteeLimitModal event={event} onClose={closeModal} />}
    </>;
};

require("./edit_invitee_limit_button.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./edit_invitee_limit_button.js");